/**
 * Ce fichier permets d'afficher la positions du point de toucher
 *
 * © Moustapha HENNAWI - Click and Take off - 2021
 */
/*-------------------------------------------------------------------------------------------*/
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import { map } from './Map';
import {
  selectAbonnementData,
  selectAerosArray,
  selectAerosVisitedArray,
  selectShowAllAeros
} from '../createSelectorUtils';
import { mapFitBound } from './mapUtil';

/*-------------------------------------------------------------------------------------------*/

PositionsAnalyse.propTypes = {
  summary: PropTypes.array
};
export default function PositionsAnalyse({ summary }) {
  const aeros = useSelector(selectAerosArray);
  const abonnement = useSelector(selectAbonnementData);
  const showAllAero = useSelector(selectShowAllAeros);

  const aerosVisitedData = useSelector(selectAerosVisitedArray);

  const aerosVisited = useMemo(
    () => (abonnement ? aerosVisitedData : []),
    [abonnement, aerosVisitedData]
  );

  const coordinatesVisited = aeros
    .filter((aero) => aerosVisited.find((item) => aero.oaci === item))
    .map((item) => [item.lon, item.lat]);

  const id = 'positionsAnalyse';

  useEffect(() => {
    map.addSource(id, {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: []
      }
    });
    map.addLayer({
      id,
      type: 'symbol',
      source: id,
      layout: {
        'icon-image': '{category}',
        'icon-size': { type: 'identity', property: 'size' },
        'icon-allow-overlap': true
      }
    });
    return () => {
      if (map.getLayer(id)) {
        map.removeLayer(id);
      }
      if (map.getSource(id)) {
        map.removeSource(id);
      }
    };
  }, []);

  useEffect(() => {
    const coordinates =
      (aeros &&
        aeros.length > 0 &&
        summary
          .map((item) =>
            item.aeros
              .map((aero) => {
                const latLon = aeros.find((item2) => item2.oaci === aero);
                if (latLon) {
                  return [latLon.lon, latLon.lat];
                }
                return null;
              })
              .filter((item) => item !== null && item.length > 0)
          )
          .filter((item) => item !== null && item.length > 0)
          .flat()) ||
      [];

    const createFeature = (aero) => {
      if (coordinates.find((item) => item[0] === aero.lon && item[1] === aero.lat)) {
        return {
          category: 'marker_blue',
          size: 1.5
        };
      }

      if (aerosVisited.find((item) => aero.oaci === item)) {
        return {
          category: 'marker_green',
          size: 0.9
        };
      }

      if (showAllAero) {
        return {
          category: 'marker_red',
          size: 0.6
        };
      }

      return {};
    };

    if (map.getSource(id) !== undefined) {
      map.getSource(id).setData({
        type: 'FeatureCollection',
        features: aeros.map((aero) => ({
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [aero.lon, aero.lat]
          },
          properties: createFeature(aero)
        }))
      });

      if (abonnement && (coordinates || coordinatesVisited)) {
        mapFitBound(coordinates.length === 0 ? coordinatesVisited : coordinates);
      } else {
        mapFitBound(aeros.map((item) => [item.lon, item.lat]));
      }
    }
  }, [
    aeros.length,
    coordinatesVisited.length,
    showAllAero,
    aerosVisited,
    aeros,
    abonnement,
    coordinatesVisited,
    summary
  ]);

  return null;
}
